import { Controller } from "@hotwired/stimulus"

// Clears all fields marked as targets within this controller's element
// Usage:
//   <div data-controller="clear-fields">
//     <input data-clear-fields-target="field" />
//     <input data-clear-fields-target="field" />
//     <button data-action="clear-fields#clear">Clear</button>
//   </div>

export default class extends Controller {
  static targets = ['field']

  clear(event) {
    event.preventDefault()

    this.element.querySelectorAll('input').forEach(field => {
      field.value = ''
      field.dispatchEvent(new Event('input', { bubbles: true }))
      field.dispatchEvent(new Event('change', { bubbles: true }))
    })

    // this.fieldTargets.forEach(field => {
    //   field.value = ''
    //   // Dispatch input and change events so Stimulus and other listeners are notified
    //   field.dispatchEvent(new Event('input', { bubbles: true }))
    //   field.dispatchEvent(new Event('change', { bubbles: true }))
    // })
  }
}
